import { createSlice } from "@reduxjs/toolkit";

export const masterDataSlice = createSlice({
  name: "masterData",
  initialState: {
    awsData: "default",
    recuitmentStatus: [
      "Applied",
      "Screened",
      "Interviewed",
      "Offer",
      "Hired",
      "Rejected",
    ],
  },

  reducers: {
    setAwsConfigData: (state, action) => {
      state.awsData = action.payload;
    },
  },
});

export const { setAwsConfigData } = masterDataSlice.actions;

export default masterDataSlice.reducer;
